// MDB UI Kit Pro Advanced
// 7.1.0
// node_modules/mdb-ui-kit/src/mdb/js/mdb.pro.es.js
import {
    // FREE
    Button,
    Carousel,
    Collapse,
    Offcanvas,
    Dropdown,
    Input,
    Modal,
    Popover,
    ScrollSpy,
    Ripple,
    Tab,
    Tooltip,
    Range,
    // PRO
    Alert,
    Animate,
    Datepicker,
    Datatable,
    Lightbox,
    Navbar,
    Popconfirm,
    Rating,
    //Sidenav,
    SmoothScroll,
    Timepicker,
    Toast,
    InfiniteScroll,
    LazyLoad,
    Stepper,
    Sticky,
    Select,
    Touch,
    PerfectScrollbar,
    Loading,
    Autocomplete,
    Clipboard,
    ChipsInput,
    Chip,
    MultiRangeSlider,
    Datetimepicker,
    initMDB,
} from 'mdb-ui-kit';

initMDB({
    // FREE
    Button,
    Carousel,
    Collapse,
    Offcanvas,
    Dropdown,
    Input,
    Modal,
    Popover,
    ScrollSpy,
    Ripple,
    Tab,
    Tooltip,
    Range,
    // PRO
    Alert,
    Animate,
    Datepicker,
    Datatable,
    Lightbox,
    Navbar,
    Popconfirm,
    Rating,
    //Sidenav,
    SmoothScroll,
    Timepicker,
    Toast,
    InfiniteScroll,
    LazyLoad,
    Stepper,
    Sticky,
    Select,
    Touch,
    PerfectScrollbar,
    Loading,
    Autocomplete,
    Clipboard,
    ChipsInput,
    Chip,
    MultiRangeSlider,
    Datetimepicker,
});
